import React from "react";
import "../styles/sobre.css"; // importa o CSS separado

const certificados = [
  "/CERTIFICADOS/1MOVIP-Autor-MtBJ20v1Ji_page-0001.jpg",
  "/CERTIFICADOS/certificado_voos_2021_page-0001.jpg",
  "/CERTIFICADOS/certificado-voos-2021b_page-0001.jpg",
  "/CERTIFICADOS/Conceito_SIAC2022_Apresentacao_page-0001.jpg",
  "/CERTIFICADOS/Corpos_Fantasticos_SIAC2023_Apresentacao_page-0001.jpg",
  "/CERTIFICADOS/Exposicao_SIAC_2023_MH_page-0001.jpg",
  "/CERTIFICADOS/Exposicao_SIAC2022_Apresentacao_page-0001.jpg",
  "/CERTIFICADOS/Exposicao_SIAC2022_MH.jpg",
  "/CERTIFICADOS/Exposicao_SIAC2023_apresentacao_page-0001.jpg",
  "/CERTIFICADOS/Festival-conheciemtno_2020_page-0001.jpg",
  "/CERTIFICADOS/Guia_Aves_Apresentacao_page-0001.jpg",
  "/CERTIFICADOS/Guia_Aves_MH_page-0001.jpg",
  "/CERTIFICADOS/Midias_SIAC2022_Apresentacao_page-0001.jpg",
];

const Sobre: React.FC = () => {
  return (
    <div className="sobre-container">
      {/* Banner */}
      <div className="sobre-banner">
        <img src="/sobre_banner.png" alt="Banner LaRC" className="banner-img" />
        <div className="banner-overlay">
          <div className="banner-text">
            <h1>
              LaRC
              <br />
              <span>Laboratório de Representação Científica - UFRJ</span>
            </h1>
          </div>
        </div>
      </div>

      {/* Texto principal */}
      <div className="sobre-texto">
        <p>
          O Voos – Laboratório de Representação Científica da UFRJ é um projeto
          que une arte, ciência e observação da natureza, com foco na avifauna
          presente nos campi da universidade. Por meio de saídas de campo,
          registros fotográficos e produção de ilustrações científicas,
          documentamos as aves da UFRJ, valorizando sua diversidade e
          contribuindo para a divulgação científica e a educação ambiental.
        </p>
        <p>
          Nosso trabalho busca criar pontes entre diferentes saberes — biologia,
          artes visuais, comunicação e educação — promovendo o olhar atento, a
          curiosidade e a preservação da biodiversidade.
        </p>
        <p>
          Além da produção de imagens, desenvolvemos materiais educativos,
          exposições, publicações e fomentamos pesquisas acadêmicas que têm as
          aves como ponto de partida para reflexão e conhecimento.
        </p>
        <p>
          Somos um espaço colaborativo, aberto ao diálogo entre ciência, arte e
          sociedade, onde cada registro se transforma em oportunidade de
          aprendizado, divulgação e encantamento pela natureza que nos cerca.
        </p>
      </div>

      {/* Certificados Grid */}
      <div className="sobre-certificados">
        <h2>Certificados</h2>
        <div className="certificados-grid">
          {certificados.map((src, idx) => (
            <div className="certificado-item" key={idx}>
              <img src={src} alt={`Certificado ${idx + 1}`} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Sobre;
